import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { HubConnectionService } from 'src/app/shared/services/realtime-connection.service';
import { destroyComponent, loadComponent, updateTimecardComplete } from './timecard.actions';
import * as HubActions from 'src/app/root-store/hub-connection-store/hub-connection.actions';
import { TimecardHubMessage } from 'src/app/shared/services/realtime-constants';

@Injectable()
export class TimecardEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _hubConnectionService: HubConnectionService
    ) {}

    timecardUpdateSuccess$ = createEffect(() => {
        return this._hubConnectionService.timecardHub
            .messagesOf<number>(TimecardHubMessage.TIMECARD_SYNC_SUCCESS)
            .pipe(map((timecardId) => updateTimecardComplete({ timecardId })));
    });

    timecardUpdateFailure$ = createEffect(() => {
        return this._hubConnectionService.timecardHub
            .messagesOf<number>(TimecardHubMessage.TIMECARD_SYNC_FAILURE)
            .pipe(map(() => updateTimecardComplete({ timecardId: null })));
    });

    connectToSignalR$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(loadComponent),
            map(() => HubActions.connectToTimecardHub())
        );
    });

    disconnectFromSignalR$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(destroyComponent),
            map(() => HubActions.disconnectFromTimecardHub())
        );
    });
}
